import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { env } from "@/env";

Vue.use(Vuetify);

import en from "vuetify/src/locale/en";
import es from "vuetify/src/locale/es";
import zh from "vuetify/src/locale/zh-Hans";
import fr from "vuetify/src/locale/fr";
import pt from "vuetify/src/locale/pt";

const opts: any = {
  lang: {
    locales: { en, es, zh, fr, pt },
    current: env.i18nLocale,
  },
  theme: {
    themes: {
      light: {
        primary: "#ff6600",
        secondary: "#ff6600",
        accent: "#ff6600",
        error: "#ed1c24",
        info: "#363636",
        success: "#72bf74",
        warning: "#faa61a",
        sgsOrange: "#ff6600",
        sgsLightGrey: "fafafa",
        sgsGrey: "#848484",
        sgsTitle: "#4b4b4b",
        sgsDarkGrey: "#363636",
      },
    },
  },
  options: {
    customProperties: false,
  },
  icons: {
    iconfont: "mdi" || "mdiSvg" || "md" || "fa" || "fa4" || "faSvg",
  },
};

export default new Vuetify(opts);
